import Account from 'modules/App/Profile/Account';
import BankCards from 'modules/BankCards';
import Dashboard from 'modules/Dashboard';
import Deposit from 'modules/Deposit';
import FundingRecords from 'modules/FundingRecords';
import Invitation from 'modules/Invitation';
import Logoff from 'modules/Logoff';
import Report from 'modules/Report';
import Security from 'modules/Security';
import Syep from 'modules/Syep';
import Transfer from 'modules/Transfer';
import Withdraw from 'modules/Withdraw';
import security from 'stores/security';

export const DASHBOARD = __('nav:个人中心');
export const WITHDRAW = __('nav:提取资金');
export const DEPOSIT = __('nav:存入资金');
export const DEPOSIT_INTRODUCE = __('nav:入金准备');
export const REPORT = __('nav:账单报表');
export const SECURITY = __('nav:安全中心');
export const TRANSFER = __('nav:转入股票');
export const DOWNLOAD = __('nav:下载APP');
export const INVITATION = __('nav:我的邀请');
export const ACCOUNT = __('nav:账户设置');
export const LOGOFF = __('nav:账号注销/账户关闭');
export const FUNDINGRECORDS = __('nav:出入金记录');
export const BANK_ACCOUNTS = __('nav:银行账户');
export const NAV_SYEP = __('nav:Stock Loan');

const isOpened = () => security.currentProcessStatusCode >= 3;

const getMenu = () => [
    {
        path: '/',
        to: '/',
        element: Dashboard,
        title: DASHBOARD
    },
    {
        path: '/security/*',
        to: '/security',
        element: Security,
        title: SECURITY
    },
    {
        path: '/account/*',
        to: '/account',
        element: Account,
        title: ACCOUNT
    },
    {
        path: '/invitation',
        to: '/invitation',
        element: Invitation,
        title: INVITATION
    },
    {
        path: '/deposit/*',
        to: '/deposit',
        element: Deposit,
        title: security.isIRAAccount ? __('Contribution') : DEPOSIT,
        isVisible: () => (isOpened() || security.isMarscoAuditing) && !security.isClosingOrDeleting
    },
    {
        path: '/withdraw/*',
        to: '/withdraw',
        element: Withdraw,
        title: security.isIRAAccount ? __('Distribution') : WITHDRAW,
        isVisible: () => isOpened() && !security.isClosingOrDeleting
    },
    {
        path: '/transfer/*',
        to: '/transfer',
        element: Transfer,
        title: TRANSFER,
        isVisible: () => isOpened() && !security.isClosingOrDeleting
    },
    {
        path: '/funding-records/*',
        to: '/funding-records',
        element: FundingRecords,
        title: FUNDINGRECORDS,
        isVisible: () => {
            // 已开户或者账户审核中的marsco可以展示出入金模块
            return security.isMarscoAccount && (isOpened() || security.currentProcessStatus === 'AUDITING');
        }
    },
    {
        path: '/bankcards/*',
        to: '/bankcards',
        element: BankCards,
        title: BANK_ACCOUNTS,
        isVisible: () => isOpened() || security.isMarscoAuditing
    },
    {
        path: '/report/*',
        to: '/report',
        element: Report,
        title: REPORT,
        isVisible: () => isOpened()
    },
    {
        path: '/logoff/*',
        to: '/logoff',
        element: Logoff,
        title: LOGOFF
    },
    {
        path: '/syep/*',
        to: '/syep',
        element: Syep,
        title: NAV_SYEP,
        // 上手是marsco的已开户用户才展示
        isVisible: () => security.isMarscoAccount && security.isAccountOpened
    }
];

export default getMenu;
